var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 720.62 580.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: #333;\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-10 {\n        opacity: .15;\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 356.63,
    cy: 231.46,
    fx: 356.63,
    fy: 231.46,
    r: 703.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0e0e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 356.64,
    cy: 231.46,
    fx: 356.64,
    fy: 231.46,
    r: 703.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 356.64,
    cy: 231.46,
    fx: 356.64,
    fy: 231.46,
    r: 703.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 356.64,
    cy: 231.46,
    fx: 356.64,
    fy: 231.46,
    r: 703.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 356.64,
    cy: 231.46,
    fx: 356.64,
    fy: 231.46,
    r: 703.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 356.63,
    cy: 231.46,
    fx: 356.63,
    fy: 231.46,
    r: 703.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 449.14,
    y1: -494.97,
    x2: 498.31,
    y2: -494.97,
    gradientTransform: "translate(-113.19 523.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e0e0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 439.31,
    y1: -468.02,
    x2: 508.14,
    y2: -468.02,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m149.61,351.91c5.79,4.84,13.3,6.95,22.52,6.33,10.4-.69,18.5-3.6,24.29-8.72,5.79-5.12,8.69-12.74,8.69-22.84v-21.94l-26.21,1.75v19.97c0,3.3-.61,5.64-1.84,7.01-1.23,1.37-2.67,2.11-4.34,2.22-1.82.12-3.28-.66-4.38-2.33-1.1-1.68-1.66-3.7-1.66-6.08v-54.88c0-2.72.39-4.87,1.18-6.46.78-1.58,2.4-2.46,4.86-2.62,4.12-.27,6.18,3.06,6.18,10.01v13.48l25.62-1.71v-20.48c0-4.52-.83-8.46-2.5-11.82-1.67-3.36-3.96-6.02-6.88-7.96-2.92-1.94-6.27-3.34-10.05-4.18-3.78-.84-7.9-1.11-12.37-.82-10.94.73-18.98,4.12-24.11,10.17-5.13,6.05-7.69,14.83-7.69,26.35v53.86c0,9.62,2.89,16.85,8.69,21.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m221.38,345.49c2.45,2.85,5.78,4.96,9.97,6.33,4.19,1.37,9.16,1.8,14.91,1.27,5.45-.22,10.27-1.29,14.46-3.22,4.2-1.93,7.52-4.48,9.97-7.66,2.45-3.17,4.28-6.73,5.48-10.68,1.2-3.94,1.8-8.27,1.8-12.98v-55.31c0-9.67-2.64-16.99-7.91-21.96-5.28-4.97-13.36-7.16-24.25-6.58-10.6.85-18.54,4.11-23.81,9.78-5.28,5.67-7.91,13.34-7.91,23.01v55.31c0,4.71.6,8.96,1.8,12.74,1.2,3.78,3.03,7.1,5.48,9.95Zm18.33-74.46v-3.54c0-.51.05-1.36.15-2.56.1-1.2.29-2.11.59-2.74.29-.63.66-1.33,1.1-2.11.44-.78,1.04-1.37,1.8-1.76.76-.39,1.66-.62,2.69-.69.74-.05,1.4,0,1.99.12.59.13,1.08.39,1.47.78.39.39.74.75,1.03,1.1.29.35.53.86.7,1.56.17.69.32,1.27.44,1.72.12.46.19,1.11.22,1.95.02.85.05,1.49.07,1.93.03.44.03,1.09,0,1.97-.02.88-.04,1.46-.04,1.75v47.23c0,1.07-.01,1.91-.04,2.52-.03.61-.09,1.49-.18,2.64-.1,1.15-.27,2.07-.51,2.77-.25.7-.58,1.44-1,2.22-.42.78-.98,1.38-1.69,1.79-.71.41-1.53.65-2.47.71-1.03.07-1.93-.08-2.69-.44-.76-.36-1.36-.94-1.8-1.74-.44-.8-.8-1.56-1.07-2.3-.27-.73-.45-1.71-.55-2.92-.1-1.21-.16-2.13-.18-2.76-.02-.63-.04-1.48-.04-2.55v-46.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "314.13 263.74 328.41 346.53 351.67 344.98 365.07 260.35 365.07 344.09 390.24 342.41 390.24 226.32 350.42 228.97 339.6 290.25 328.7 230.42 289.25 233.04 289.25 349.14 314.13 347.48 314.13 263.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "428.08 223.8 403.05 225.47 403.05 341.56 428.08 339.89 428.08 223.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "466.21 279.27 479.16 336.49 504.48 334.81 504.48 218.71 479.46 220.38 479.46 275.91 467.53 221.17 440.89 222.95 440.89 339.04 466.21 337.36 466.21 279.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m543.72,333.51c9.62-.64,16.73-4.83,21.35-12.57l4.42,9.54,10.08-.67v-67.63l-31.36,2.09v20.04l6.92-.46v13.41c0,4.52-.43,7.82-1.29,9.89-.86,2.07-2.59,3.2-5.19,3.37-1.57.1-2.86-.16-3.87-.8-1.01-.64-1.73-1.62-2.17-2.95-.44-1.33-.72-2.58-.85-3.73-.12-1.16-.18-2.59-.18-4.29v-44.89c0-2.91.02-5.05.07-6.42.05-1.36.2-2.82.44-4.37.25-1.55.63-2.63,1.14-3.24.51-.62,1.23-1.15,2.13-1.6.91-.45,2.1-.72,3.57-.82.74-.05,1.4,0,1.99.12.59.13,1.24.43,1.95.89.71.46,1.26,1.29,1.66,2.48.39,1.19.59,2.71.59,4.55v9.18l24.73-1.65c0-3.16-.06-5.9-.18-8.22-.12-2.32-.36-4.82-.7-7.5-.35-2.67-.85-4.95-1.51-6.82-.66-1.87-1.52-3.76-2.58-5.66-1.06-1.9-2.39-3.46-4.01-4.69-1.62-1.23-3.5-2.31-5.63-3.23-2.13-.93-4.68-1.55-7.62-1.86-2.94-.31-6.23-.35-9.86-.11-2.95.2-5.68.56-8.21,1.09-2.53.53-5.34,1.56-8.43,3.08-3.09,1.52-5.7,3.45-7.84,5.81-2.14,2.35-3.94,5.62-5.41,9.8-1.47,4.18-2.21,9.01-2.21,14.5v50.29c0,23.95,9.35,35.31,28.05,34.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m220.55,545.31c-15.98,1.06-27.38-1.79-34.19-8.57-6.82-6.78-10.22-17.72-10.22-32.83v-15.11l34.04-2.27v13.85c0,9.94,2.74,14.73,8.22,14.37,2.54-.17,4.55-1.27,6.02-3.31,1.47-2.03,2.2-4.63,2.2-7.8,0-4.13-.57-7.58-1.71-10.35-1.14-2.77-2.87-5.35-5.18-7.74-2.32-2.4-6.12-5.68-11.4-9.85l-14.58-11.52c-11.74-9.23-17.61-20.14-17.61-32.73,0-13.69,3.54-24.11,10.61-31.27,7.08-7.15,16.81-11.14,29.2-11.97.33-.02.62-.04.88-.06.26-.02,1.99-.13,5.19-.34,3.19-.21,7.3.24,12.33,1.36,5.02,1.12,9.49,3.24,13.4,6.37,3.91,3.13,6.85,7.65,8.8,13.56,1.96,5.91,2.93,13.22,2.93,21.94l-34.92,2.32-.2-9.29c-.07-1.74-.82-3.24-2.25-4.5-1.43-1.26-3.03-1.83-4.79-1.71-2.29.15-4.22.97-5.82,2.47-1.6,1.5-2.4,3.34-2.4,5.53,0,4.39,3.23,8.96,9.68,13.69l20.84,15.27c3.39,2.49,6.34,5.05,8.85,7.69,2.51,2.64,4.5,5.29,5.97,7.93,1.47,2.65,2.66,5.05,3.57,7.22.91,2.17,1.55,4.55,1.91,7.14.36,2.59.57,4.55.64,5.87.07,1.32.1,3.05.1,5.18,0,5.42-.36,10.37-1.08,14.84-.72,4.47-1.99,8.82-3.81,13.04-1.83,4.22-4.22,7.8-7.19,10.75-2.97,2.94-6.82,5.38-11.54,7.31-4.73,1.93-10.22,3.1-16.48,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m270.93,498.56v-73.51c0-12.85,3.5-23.04,10.51-30.58,7.01-7.54,17.56-11.87,31.65-13,14.48-.77,25.22,2.15,32.24,8.75,7.01,6.6,10.52,16.33,10.52,29.18v73.51c0,6.26-.8,12.02-2.4,17.26-1.6,5.24-4.03,9.97-7.29,14.19-3.26,4.22-7.68,7.62-13.25,10.18s-11.98,3.99-19.22,4.28c-7.63.7-14.23.14-19.81-1.68-5.58-1.82-10-4.63-13.25-8.42-3.26-3.78-5.69-8.19-7.29-13.22-1.6-5.03-2.4-10.67-2.4-16.94Zm42.46,10.06c1.24-.08,2.33-.4,3.28-.94.94-.55,1.69-1.34,2.25-2.38.55-1.04.99-2.02,1.32-2.94.33-.92.55-2.15.68-3.68.13-1.52.21-2.69.25-3.5.03-.81.05-1.93.05-3.35v-62.76c0-.39.01-1.16.05-2.33.03-1.16.03-2.04,0-2.61-.03-.58-.07-1.43-.1-2.56-.03-1.13-.13-1.99-.29-2.6-.16-.6-.36-1.36-.59-2.29-.23-.92-.54-1.61-.93-2.07-.39-.46-.85-.94-1.37-1.46-.52-.51-1.18-.86-1.96-1.03-.78-.17-1.66-.23-2.64-.16-1.37.09-2.56.4-3.57.91-1.01.52-1.81,1.3-2.4,2.34-.59,1.04-1.08,1.98-1.47,2.81-.39.83-.65,2.05-.78,3.64-.13,1.59-.2,2.72-.2,3.4v66.68c0,1.42.02,2.55.05,3.39.03.84.11,2.06.25,3.66.13,1.61.37,2.9.73,3.87.36.98.83,2,1.42,3.05.59,1.06,1.38,1.83,2.4,2.31,1.01.48,2.2.68,3.57.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m368.76,492.05v-73.51c0-12.85,3.5-23.04,10.52-30.58,7.01-7.54,17.56-11.87,31.65-13,14.48-.77,25.22,2.15,32.24,8.75,7.01,6.61,10.52,16.33,10.52,29.18v73.51c0,6.26-.8,12.02-2.4,17.25-1.6,5.24-4.03,9.97-7.29,14.19-3.26,4.22-7.68,7.62-13.26,10.18-5.58,2.57-11.98,3.99-19.22,4.28-7.63.7-14.23.14-19.81-1.68-5.58-1.82-10-4.63-13.26-8.42-3.26-3.79-5.69-8.19-7.29-13.22-1.6-5.03-2.4-10.67-2.4-16.94Zm42.46,10.06c1.24-.08,2.33-.4,3.28-.94.94-.55,1.69-1.34,2.25-2.38.55-1.04.99-2.02,1.32-2.94.33-.93.55-2.15.68-3.68.13-1.52.21-2.69.25-3.5.03-.81.05-1.92.05-3.35v-62.76c0-.39.01-1.16.05-2.33.03-1.16.03-2.04,0-2.61-.03-.58-.07-1.43-.1-2.56-.03-1.13-.13-1.99-.29-2.59-.16-.6-.36-1.36-.59-2.29-.23-.92-.54-1.61-.93-2.07-.39-.46-.85-.94-1.37-1.46-.52-.51-1.18-.86-1.96-1.03-.78-.17-1.66-.23-2.64-.16-1.37.09-2.56.4-3.57.91-1.01.52-1.81,1.3-2.4,2.34-.59,1.04-1.08,1.98-1.47,2.81-.39.83-.65,2.05-.78,3.64-.13,1.59-.2,2.72-.2,3.4v66.68c0,1.42.02,2.55.05,3.39.03.84.11,2.06.24,3.66.13,1.61.37,2.9.73,3.87.36.98.83,2,1.42,3.05s1.38,1.83,2.4,2.31c1.01.48,2.2.68,3.57.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m553.16,367.13v154.29l-33.65,2.24-17.22-76.05v77.19l-33.65,2.24v-154.29l35.41-2.36,15.85,72.75v-73.8l33.26-2.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m360.54,0C346.96,0,335.96,3.67,335.96,8.19v48.42h49.17V8.19C385.12,3.67,374.11,0,360.54,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m360.54,9.89c-19.01,0-34.42,5.14-34.42,11.47v79.28h68.83V21.36c0-6.34-15.41-11.47-34.42-11.47Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m360.54,108.17c19.01,0,34.42-3.37,34.42-7.54s-15.41-7.54-34.42-7.54-34.42,3.37-34.42,7.54,15.41,7.54,34.42,7.54Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 720.62,
    height: 580.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.d32338c4bc9873ee332bdbc157a6907f.svg";
export { ForwardRef as ReactComponent };